import axios from 'axios';
const configUrl = `https://config-api.ken42.com/v1/configs/url`;
let axiosInstance;
let applicationConfig;
let paymentInstance;

// command to run json server is : json-server --watch db.json --port 4000

const getInsConfig = (config) => {
  return config;
};

const getAxiosInstance = async (data) => {
  applicationConfig = await getInsConfig(data);
  axiosInstance = await axios.create({
    baseURL: `${applicationConfig.apiURL}`,
  });
  // Request interceptor for API calls
  axiosInstance.interceptors.request.use((req) => {
    const token = localStorage.getItem('access_token');
    req.headers.Authorization = `Bearer ${token}`;
    return req;
  });

  //Response interceptor for API calls
  axiosInstance.interceptors.response.use(
    (resp) => {
      // console.log(resp);
      return resp;
    },
    async function (error) {
      //console.log(error.response.status);
      var config = {
        method: 'get',
        baseURL: applicationConfig.tokenURL, //'https://api-dev.ken42.com:8243/token?grant_type=client_credentials',
        // headers: {
        //   Authorization: `Basic ${applicationConfig.tokenAuth}`,
        // },
      };
        return axios(config).then(function (response) {
        // console.log(JSON.stringify(response.data.access_token));
        localStorage.setItem('access_token', response.data.access_token);
        error.response.config.headers[
          'Authorization'
        ] = `Bearer ${response.data.access_token}`;
        return axios(error.response.config);
      });
    }
  );
  return axiosInstance;
};

export const getPaymentInstance = () => {
  paymentInstance = axios.create({
    baseURL: `${applicationConfig.zqBaseURL}`,
  });
  paymentInstance.interceptors.request.use((req) => {
    const token = localStorage.getItem('zq_access_token');
    req.headers.Authorization = token;
    return req;
  });

  paymentInstance.interceptors.response.use(
    (resp) => {
      // console.log(resp);
      return resp;
    },
    async function (error) {
      var config = {
        method: 'post',
        baseURL: `${applicationConfig.zqBaseURL}/login`,
        data: {
          username: `${applicationConfig.zqUserName}`,
          password: `${applicationConfig.zqPassword}`,
        },
      };
      // console.log(error);
      return axios(config).then(function (response) {
        // console.log("RESPOSNE::::", response);
        localStorage.setItem('zq_access_token', response.data.token);
        error.response.config.headers['Authorization'] = response.data.token;
        return axios(error.response.config);
      });
    }
  );
};

// create contactApi
const createContact = async (data) => {
  const res = await axiosInstance.post('/createData?api=contactApi', data);
  return res && res.data ? res.data : null;
};

// get contactInfo using phone
const getContactByPhone = async (phone) => {
  const path = `/getData?api=contactApi?phone=${phone}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

// get contactInfo using emailId
const getContactByEmailId = async (emailId) => {
  const path = `/getData?api=contactApi?emailId=${emailId}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

// create application
const createApplication = async (data) => {
  const res = await axiosInstance.post(`/createData?api=applicationApi`, data);
  return res && res.data ? res.data : null;
};

// get application by contactId || applicationId
const getApplicationById = async (contactId,applicationId) => {
  let path
  if(contactId){
    path = `/getData?api=applicationApi?contactId=${contactId}`
  }else{
    path = `/getData?api=applicationApi?applicationId=${applicationId}`
  }
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

//inser job role
const insertJobRole = async (data) => {
  const res = await axiosInstance.post(`/createData?api=jobRoleApi`, data);
  return res && res.data ? res.data : null;
};

// get jobRole using applicationId
const getJobRole = async (Id) => {
  const path = `/getData?api=jobRoleApi?applicationId=${Id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

// delete jobRole using Id
const deleteJobRole = async (Id) => {
  const path = `/deleteData?api=jobRoleApi?Id=${Id}`;
  const res = await axiosInstance.delete(path);
  return res && res.data ? res.data : null;
};

//Create Director 
const createDirector = async (data) => {
  const res = await axiosInstance.post(`/createData?api=directorApi`, data);
  return res && res.data ? res.data : null;
};

// get director using applicationId
const getDirector = async (Id) => {
  const path = `/getData?api=directorApi?applicationId=${Id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

//deleteDirectorBy using Id
const deleteDirectorById = async (Id) => {
  const path = `/deleteData?api=directorApi?Id=${Id}`;
  const res = await axiosInstance.delete(path);
  return res && res.data ? res.data : null;
};

//Insert Institute  Recognition,
const insertRecognitionOfInstitute = async (data) => {
  const res = await axiosInstance.post(`/createData?api=RecognitionApi`, data);
  return res && res.data ? res.data : null;
};

// get institute using applicationId
const getRecognitionOfInstitute = async (Id) => {
  const path = `/getData?api=RecognitionApi?applicationId=${Id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

//deleteInstituteRecognition using Id
const deleteInstituteRecognition = async (Id) => {
  const path = `/deleteData?api=RecognitionApi?Id=${Id}`;
  const res = await axiosInstance.delete(path);
  return res && res.data ? res.data : null;
};

//Insert spoc,
const insetSpoc = async (data) => {
  const res = await axiosInstance.post(`/createData?api=spocApi`, data);
  return res && res.data ? res.data : null;
};

// get spoc using applicationId
const getSpoc = async (Id) => {
  const path = `/getData?api=spocApi?applicationId=${Id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

//Insert Trainner,
const insertTrainer = async (data) => {
  const res = await axiosInstance.post(`/createData?api=TrainersApi`, data);
  return res && res.data ? res.data : null;
};

// get Trainner using applicationId
const getTrainner = async (Id) => {
  const path = `/getData?api=TrainersApi?applicationId=${Id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

//deleteTrainner using Id
const deleteTrainnerById = async (Id) => {
  const path = `/deleteData?api=TrainersApi?Id=${Id}`;
  const res = await axiosInstance.delete(path);
  return res && res.data ? res.data : null;
};

//Insert Trainner,
const insertSupportStaff = async (data) => {
  const res = await axiosInstance.post(`/createData?api=SupportStaffApi`, data);
  return res && res.data ? res.data : null;
};

// get SupportStaff using applicationId
const getSupportStaff = async (Id) => {
  const path = `/getData?api=SupportStaffApi?applicationId=${Id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

//Insert Scheme,
const insertScheme = async (data) => {
  const res = await axiosInstance.post(`/createData?api=SchemesApi`, data);
  return res && res.data ? res.data : null;
};

// get SupportStaff using applicationId
const getSheme = async (Id) => {
  const path = `/getData?api=SchemesApi?applicationId=${Id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

//deleteScheme using Id
const deleteSchemeById = async (Id) => {
  const path = `/deleteData?api=SchemesApi?Id=${Id}`;
  const res = await axiosInstance.delete(path);
  return res && res.data ? res.data : null;
};

//Insert industry,
const insertIndustry = async (data) => {
  const res = await axiosInstance.post(`/createData?api=IndustryApi`, data);
  return res && res.data ? res.data : null;
};

// get industry using applicationId
const getIndustry = async (Id) => {
  const path = `/getData?api=IndustryApi?applicationId=${Id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

//deleteIndustry using Id
const deleteIndustryById = async (Id) => {
  const path = `/deleteData?api=IndustryApi?Id=${Id}`;
  const res = await axiosInstance.delete(path);
  return res && res.data ? res.data : null;
};

//Insert Aspect,
const insertAspect = async (data) => {
  const res = await axiosInstance.post(`/createData?api=AspectsApi`, data);
  return res && res.data ? res.data : null;
};

// get Aspect using applicationId
const getAspect = async (Id) => {
  const path = `/getData?api=AspectsApi?applicationId=${Id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

// insert center Details
const insertCenterDetails = async (data) => {
  const res = await axiosInstance.post(`/createData?api=centreDetailsFormatApi`, data);
  return res && res.data ? res.data : null;
};

// center Details
const getCenterDetails = async (Id) => {
  const path = `/getData?api=centreDetailsFormatApi?applicationId=${Id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

// insert hr Details
const insertHr = async (data) => {
  const res = await axiosInstance.post(`/createData?api=HRmanagerApi`, data);
  return res && res.data ? res.data : null;
};

// get hr Details
const getHr = async (Id) => {
  const path = `/getData?api=HRmanagerApi?applicationId=${Id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

// get uploads using application Id
const getUploadDetails = async (ID) => {
  const path = `/getData?api=ContactAttachment?recordId=${ID}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

// delete Attachment File
const deleteFile = async (Id) => {
  const path = `/deleteData?api=ContactAttachment?Id=${Id}`;
  const res = await axiosInstance.delete(path);
  return res && res.data ? res.data : null;
};


const payApplicationFees = async (data) => {
  // console.log(data,'data..............');
  const res = await axios.post(
    `${applicationConfig.zqBaseURL}createApplication?orgId=${applicationConfig.orgId}`,
    data
  );
  return res && res.data ? res.data : null;
};

const paymentReceipt = async (data) => {
  const res = await axios.post(
    `${applicationConfig.zqBaseURL}sendReceipt?institute=${applicationConfig.institue}&orgId=${applicationConfig.orgId}`,
    data
  );
  return res && res.data ? res.data : null;
};

const payApplicationFeesByPayU = async (data) => {
  const res = await axios.post(
    `${applicationConfig.zqBaseURL}createPayuPayment?orgId=${applicationConfig.orgId}`,
    data
  );
  return res && res.data ? res.data : null;
};

// get academic programs
const getAcademicPrograms = async () => {
  const path = `/academic-program`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

const getAcademicTree = async (id) => {
  const path = `/account/${id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};
//landing page api

const getInstitutes=async()=>{
  const path = `/account/institute/0`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
}

const progbyinstitute=async(id)=>{
  const path=`/account/academicprogram/${id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
}

const getacademicyears=async(id)=>{
  const path=`/account/academicyears/${id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
}

const getacademicProgramInfo = async (contactID,year) => {
  const path = `/academic-program/${contactID}/${year}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};
//https://api-dev.ken42.com:8243/integration/1.0.0/account/0

// get application status
const getApplicationStatus = async (input) => {
  const res = await axiosInstance.get(`/application-status/${input}`);
  return res && res.data ? res.data : null;
};

// create student relationships
const createRelationships = async (data) => {
  const res = await axiosInstance.post('/Relationships', data);
  return res && res.data ? res.data : null;
};

// create student categories
const createCategories = async (data) => {
  const res = await axiosInstance.post('/Categories', data);
  return res && res.data ? res.data : null;
};

// create student address
const createAddress = async (data) => {
  const res = await axiosInstance.post('/address', data);
  return res && res.data ? res.data : null;
};

// get applicant details
const getApplicantDetails = async (contactID, AppID) => {
  const path = `/applicant/${contactID}/${AppID}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

//get academic program detail
const getAcademicProgramsDetails = async (ContactID, AppID) => {
  const path = `/academic-details/${ContactID}/${AppID}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

//post academic program detail
const postAcademicProgramsDetails = async (data) => {
  const path = `/academic-details`;
  const res = await axiosInstance.post(path, data);
  return res && res.data ? res.data : null;
};

//delete academic program detail
const deleteAcademicProgramsDetails = async (id) => {
  const path = `/academic-details/${id}`;
  const res = await axiosInstance.delete(path);
  return res && res.data ? res.data : null;
};

// get relationship details
const getRelationshipDetails = async (contactID) => {
  const path = `/Relationships/${contactID}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

//delete relations
const deleteRelation = async (id) => {
  const path = `/Relationships/${id}`;
  const res = await axiosInstance.delete(path);
  return res && res.data ? res.data : null;
};

// get address details
const getAddressDetails = async (contactID) => {
  const path = `/address/${contactID}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

//delete address detail
const deleteAddressDetails = async (id) => {
  const path = `/address/${id}`;
  const res = await axiosInstance.delete(path);
  return res && res.data ? res.data : null;
};

// update application
const updateApplication = async (data, appId) => {
  const path = `applicant/${data.ContactId}/${appId}`;
  const res = await axiosInstance.put(path, data);
  return res && res.data ? res.data : null;
};

// submit application
const submitApplication = async (data) => {
  const path = `/application-status`;
  const res = await axiosInstance.post(path, data);
  return res && res.data ? res.data : null;
};

const getApplicantInfo = async (contactID, AppId) => {
  const path = `/applicant/${contactID}/${AppId}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

const getContactInfo = async (contactID) => {
  const path = `/applicant/${contactID}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

const getAttributes = async (contactID) => {
  const path = `/attributes/${contactID}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

const createAttribute = async (data) => {
  const path = `/attributes`;
  const res = await axiosInstance.post(path, data);
  return res && res.data ? res.data : null;
};

const getPreferences = async (AppId) => {
  const path = `/preference/${AppId}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

const createPreferences = async (data) => {
  const path = `/preference`;
  const res = await axiosInstance.post(path, data);
  return res && res.data ? res.data : null;
};

const deletePreference = async (id) => {
  const path = `/preference/${id}`;
  const res = await axiosInstance.delete(path);
  return res && res.data ? res.data : null;
};

// get application status
const getApplicationStatusByEmail = async (email) => {
  const res = await axiosInstance.get(`/application-status`, {
    params: {
      emailId: email,
    },
  });
  return res && res.data ? res.data : null;
};

//OTP APIs
const sendOtp = async (queryParams) => {
  const path = `${applicationConfig.smsURL}/otp?${queryParams}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

const validateOtp = async (queryParams) => {
  const path = `${applicationConfig.smsURL}/validateotp?${queryParams}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

const getConfig = async () => {
  const path = `${window.location.host}`;
  // const path = "essci-stg-applicationportal.ken42.com"
  const res = await axios.get(`${configUrl}/${path}`);
  return res && res.data ? res.data : null;
};

//Document UPLOAD API
const uploadDocuments = async (upload) => {
  const path = `${applicationConfig.integartionUrl}/salesforce/blob?contactId=${upload.contactId}&fileName=${upload.newFileName}`;
  const res = await axiosInstance.post(path, upload.data, {
    enctype: 'multipart/form-data',
    processData: false,
    contentType: false,
  });
  return res && res.data ? res.data : null;
};

export {
  getAcademicPrograms,
  getAddressDetails,
  createRelationships,
  createCategories,
  createAddress,
  getAcademicProgramsDetails,
  postAcademicProgramsDetails,
  deleteAcademicProgramsDetails,
  getApplicantDetails,
  getRelationshipDetails,
  updateApplication,
  submitApplication,
  getUploadDetails,
  getAcademicTree,
  payApplicationFees,
  paymentReceipt,
  deleteFile,
  deleteAddressDetails,
  deleteRelation,
  getApplicantInfo,
  getAttributes,
  createAttribute,
  getPreferences,
  createPreferences,
  deletePreference,
  getContactInfo,
  getApplicationStatusByEmail,
  sendOtp,
  validateOtp,
  getConfig,
  getAxiosInstance,
  uploadDocuments,
  getInstitutes,
  progbyinstitute,
  getacademicyears,
  getacademicProgramInfo,
  axiosInstance,
  createApplication,
  createContact,
  getContactByPhone,
  getContactByEmailId,
  insertJobRole,
  getJobRole,
  deleteJobRole,
  createDirector,
  getDirector,
  deleteDirectorById,
  insertRecognitionOfInstitute,
  getRecognitionOfInstitute,
  deleteInstituteRecognition,
  insetSpoc,
  getSpoc,
  insertTrainer,
  getTrainner,
  deleteTrainnerById,
  insertSupportStaff,
  getSupportStaff,
  insertScheme,
  getSheme,
  deleteSchemeById,
  insertIndustry,
  getIndustry,
  deleteIndustryById,
  getApplicationById,
  insertAspect,
  getAspect,
  insertCenterDetails,
  getCenterDetails,
  insertHr,
  getHr,
  payApplicationFeesByPayU
};
